module.exports = __webpack_public_path__ + "static/media/spaanse_wegen.b813c0b5.jpg";